<section class="doctor-scheduler">
  <vc-spinner *ngIf="loading"></vc-spinner>
  <div *ngIf="!loading">
    <div class="w-100 px-2">
      <p-messages severity="info">
        <ng-template pTemplate>
          Add your typical work-week schedule. If you have alternating work weeks, such as different doctors every other
          week, you can add additional weeks.
        </ng-template>
      </p-messages>
    </div>
    <div class="d-flex m-2 pt-2">
      <div class="m-2">
        <span class="p-float-label">
          <p-dropdown [options]="practices"
                      inputId="practices"
                      [(ngModel)]="selectedPractice"
                      optionLabel="nameId"
                      [filter]="true"
                      filterBy="nameId"
                      [showClear]="true"
                      placeholder="Select a Practice"
                      (onChange)="practiceSelected($event)"></p-dropdown><label for="practices">Practice</label></span>
      </div>
      <div class="m-2"
           *ngIf="selectedPractice  && !scheduleLoading"><span class="p-float-label">
          <p-calendar [(ngModel)]="selectedWeekStartDate"
                      inputId="week1"
                      [disabledDays]="[1,2,3,4,5,6]"
                      (onSelect)="onStartDateChanged($event)"></p-calendar>
          <label for="week1">Start of week 1</label>
        </span>
      </div>
      <div class="m-2"
           *ngIf="selectedPractice && !scheduleLoading">
		   
		   
        <!--<p-tabMenu [model]="tabs"
                   [activeItem]="selectedTab"
                   (activeItemChange)="onActiveItemChange($event)">
          <ng-template pTemplate="item"
                       let-item
                       let-i="index">
            <div class="tab">Week {{i+1}} <span *ngIf="i>0">(Alternating)</span>
              <div class="delete-btn-container"><p-button *ngIf="tabs.length>1 && item==selectedTab"
                          (onClick)="removeWeek(item)"
                          styleClass="p-button-link delete-btn"><i style="font-size:12px"
                     class="pi pi-times"></i></p-button></div>
            </div>
          </ng-template>
        </p-tabMenu>-->
		
	  <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="onTabChanged($event)">
		  <p-tabPanel *ngFor="let tab of tabs; let i = index">
			<ng-template pTemplate="header">
			  <div class="tab">
				{{ tab.label }}
				<span *ngIf="tab.alternating">(Alternating)</span>
				<a href="#"
				   class="delete-tab-link"
				   *ngIf="tabs.length > 1 && i === activeTabIndex"
				   (click)="removeWeek(i); $event.preventDefault()">
				  <i class="pi pi-times" style="font-size: 12px;"></i>
				</a>
			  </div>
			</ng-template>
		  </p-tabPanel>
	</p-tabView>



      </div>
      <div class="m-2"
           *ngIf="selectedPractice && !scheduleLoading">
        <p-splitButton label="Add alternating week"
                       appendTo="body"
                       icon="pi pi-plus"
                       [disabled]="tabs.length>8 || working"
                       (onClick)="addWeek()"
                       [model]="cloneMenuItems">Add alternating week</p-splitButton>
      </div>
    </div>
    <vc-spinner *ngIf="selectedPractice && scheduleLoading"></vc-spinner>
    <div class="m-2"
         *ngIf="selectedPractice && !scheduleLoading">
      <div>
        <p-table [value]="rows"
                 [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th [style]="'width:12.5%'">Name</th>
              <th [style]="'width:12.5%'"
                  *ngFor="let i of weekdays">
                {{ getWeekDayName(i) }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
                       let-doctor
                       let-ri="rowIndex">
            <tr>
              <td [style]="'width:12.5%'"
                  [class.firstRow]="ri==0">{{doctor.employeeName}}<span *ngIf="ri==0"> - Hospital Wide</span>
                <div style="display:flex"
                     *ngIf="ri!=0"><p-checkbox name="notassigned"
                              [binary]="true"
                              (onChange)="onNotAssignedChange($event.checked,doctor.employeeNumber)"
                              [(ngModel)]="doctor.employeeIsNotAssignedToPractice"
                              [inputId]="'notassigned'+ri"></p-checkbox>
                  <label class="p-1 m-0"
                         [for]="'notassigned'+ri">Doesn't work here</label>
                </div>
              </td>
              <td [style]="'width:12.5%'"
                  *ngFor="let i of weekdays">
                <div>
                  <div *ngIf="!doctor.weekDays[i].practiceScheduleDayId">
                    <span class="addBtn"> <p-button icon="pi pi-plus"
                                [disabled]="ri!=0 && doctor.employeeIsNotAssignedToPractice"
                                styleClass="p-button-rounded p-button-text"
                                (onClick)="openModal(doctor,i)"></p-button></span>
                  </div>
                  <div *ngIf="doctor.weekDays[i].practiceScheduleDayId">

                    <div class="mainschedulebar">{{timeFormat(doctor.weekDays[i].startTime)}} -
                      {{timeFormat(doctor.weekDays[i].endTime)}}<br />
                      Appts: {{timeFormat(doctor.weekDays[i].firstAppt)}} - {{timeFormat(doctor.weekDays[i].lastAppt)}}
                      <p-button (onClick)="openModal(doctor,i)"
                                [disabled]="ri!=0 && doctor.employeeIsNotAssignedToPractice"
                                styleClass="p-button-link float-right m-0 barbtn"><i
                           class="pi pi-pencil"></i></p-button>
                    </div>
                    <div *ngFor="let blockoff of doctor.weekDays[i].blockoffs"
                         class="blockoffbar mt-1  d-flex justify-content-between align-items-center">
                      <div [pTooltip]="blockoff.reason">
                        <div>{{timeFormat(blockoff.startTime)}} -
                          {{timeFormat(blockoff.endTime)}}</div>
                        <div>{{getBlockoffTypeName(blockoff.blockoffTypeSKey)}}</div>
                      </div>
                      <p-button (onClick)="openBlockoffModal(doctor,i,blockoff)"
                                [disabled]="ri!=0 && doctor.employeeIsNotAssignedToPractice"
                                styleClass="p-button-link float-right m-0 barbtn"><i
                           class="pi pi-pencil"></i></p-button>
                    </div>
                    <div *ngIf="ri>0"><p-button (onClick)="openBlockoffModal(doctor,i,undefined)"
                                [disabled]="ri!=0 && doctor.employeeIsNotAssignedToPractice"
                                styleClass="p-button-link p-button-warning p-button-text float-right m-0 p-1"><i
                           class="pi pi-plus-circle"></i><span class="pl-1"
                              style="font-size: 12px;">Add blockoff</span></p-button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-dialog header="Edit schedule"
            [(visible)]="scheduleDialogShown"
            [modal]="true"
            [style]="{ width: '50vw' }"
            [draggable]="false"
            [resizable]="false">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label"
               for="start-time">Start Time</label>
        <p-calendar inputId="start-time"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedSchedule.startTimeDate"
                    hourFormat="12"
                    [maxDate]="selectedSchedule.endTimeDate"
                    (onBlur)="onTimeBlur($event,selectedSchedule,'startTimeDate')"></p-calendar>
      </div>
      <div class="col-md-6">
        <label class="form-label"
               for="end-time">End Time</label>
        <p-calendar inputId="end-time"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedSchedule.endTimeDate"
                    hourFormat="12"
                    [minDate]="selectedSchedule.startTimeDate"
                    (onBlur)="onTimeBlur($event,selectedSchedule,'endTimeDate')"></p-calendar>
      </div>
      <div class="col-md-6">
        <label class="form-label"
               for="first-appt">First Appt</label>
        <p-calendar inputId="first-appt"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedSchedule.firstApptDate"
                    hourFormat="12"
                    [maxDate]="getMinDate([selectedSchedule.lastApptDate,selectedSchedule.endTimeDate])"
                    [minDate]="selectedSchedule.startTimeDate"
                    (onBlur)="onTimeBlur($event,selectedSchedule,'firstApptDate')"></p-calendar>
      </div>
      <div class="col-md-6">
        <label class="form-label"
               for="last-appt">Last Appt</label>
        <p-calendar inputId="last-appt"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedSchedule.lastApptDate"
                    hourFormat="12"
                    [minDate]="getMaxDate([selectedSchedule.firstApptDate,selectedSchedule.startTimeDate])"
                    [maxDate]="selectedSchedule.endTimeDate"
                    (onBlur)="onTimeBlur($event,selectedSchedule,'lastApptDate')"></p-calendar>
      </div>
      <div class="col-md-12 py-2">
        <label class="form-label w-100"
               for="last-appt">Copy to</label>
        <div class="d-flex align-items-center">
          <div *ngFor="let weekday of weekdays"
               class="d-flex align-items-center p-2">
            <p-checkbox name="wdgroup"
                        [value]="weekday"
                        [inputId]="'wd'+weekday"
                        [(ngModel)]="copyTo"
                        [disabled]="weekday==selectedSchedule.weekday"></p-checkbox>
            <label class="p-1"
                   [for]="'wd'+weekday">{{ getWeekDayName(weekday) }}</label>
          </div>
        </div>
      </div>
      <div *ngIf="selectedSchedule.employeeNumber"
           class="col-md-12 p-2">
        <p-messages severity="warn">
          <ng-template pTemplate>
            To add lunch time, you can create a blockoff after saving this popup.
          </ng-template>
        </p-messages>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button *ngIf="this.selectedSchedule.practiceScheduleDayId>0"
                icon="pi pi-times"
                (click)="deleteSchedule()"
                label="Delete"
                styleClass="p-button-danger p-button-text"></p-button>
      <p-button icon="pi pi-check"
                (click)="saveSchedule()"
                label="Save"
                styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>
  <p-dialog [header]="(selectedBlockoff.scheduleBlockoffId ? 'Edit' : 'Add') + ' block off'"
            [(visible)]="blockoffDialogShown"
            [modal]="true"
            [style]="{ width: '50vw' }"
            [draggable]="false"
            [resizable]="false">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label"
               for="start-time">Start Time</label>
        <p-calendar inputId="start-time"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedBlockoff.startTimeDate"
                    hourFormat="12"
                    [maxDate]="getMinDate([selectedBlockoff.endTimeDate, selectedSchedule.endTimeDate])"
                    [minDate]="selectedSchedule.startTimeDate"
                    (onBlur)="onTimeBlur($event,selectedBlockoff,'startTimeDate')"></p-calendar>
      </div>
      <div class="col-md-6">
        <label class="form-label"
               for="end-time">End Time</label>
        <p-calendar inputId="end-time"
                    [timeOnly]="true"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    [inputStyle]="{'width':'100%'}"
                    [(ngModel)]="selectedBlockoff.endTimeDate"
                    hourFormat="12"
                    [minDate]="getMaxDate([selectedBlockoff.startTimeDate, selectedSchedule.startTimeDate])"
                    [maxDate]="selectedSchedule.endTimeDate"
                    (onBlur)="onTimeBlur($event,selectedBlockoff,'endTimeDate')"></p-calendar>
      </div>
      <div class="col-md-6">
        <label class="form-label"
               for="bofftype">Blockoff Type</label>
        <p-dropdown inputId="bofftype"
                    [options]="blockoffTypes"
                    [style]="{'width':'100%'}"
                    appendTo="body"
                    [(ngModel)]="selectedBlockoff.blockoffTypeSKey"
                    optionLabel="blockoffTypeName"
                    optionValue="blockoffTypeSKey"></p-dropdown>
      </div>

      <div class="col-md-6">
        <label class="form-label"
               for="reason">Reason</label>
        <input type="text"
               pInputText
               inputId="reason"
               class="w-100"
               [style]="{'width':'100%'}"
               [(ngModel)]="selectedBlockoff.reason" />
      </div>

      <div class="col-md-12 py-2">
        <label class="form-label w-100"
               for="last-appt">Copy to</label>
        <div class="d-flex align-items-center">
          <div *ngFor="let weekday of weekdays"
               class="d-flex align-items-center p-2">
            <p-checkbox name="wdgroup"
                        [value]="weekday"
                        [inputId]="'wd'+weekday"
                        [(ngModel)]="copyTo"
                        [disabled]="weekday==selectedSchedule.weekday"></p-checkbox>
            <label class="p-1"
                   [for]="'wd'+weekday">{{ getWeekDayName(weekday) }}</label>
          </div>
        </div>
      </div>

    </div>
    <ng-template pTemplate="footer">
      <p-button *ngIf="this.selectedBlockoff.scheduleBlockoffId>0"
                icon="pi pi-times"
                (click)="deleteBlockoff()"
                label="Delete"
                styleClass="p-button-danger p-button-text"></p-button>
      <p-button icon="pi pi-check"
                (click)="saveBlockoff()"
                label="Save"
                styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>

</section>